import * as EserviceCommon from 'sos-eservice-common/js/components';

import 'sos-common/sass/style.scss'; //Common styles
import '../../sass/style.scss';
import { PreAnsokan } from './PreAnsokan/PreAnsokan';
import { LegAnsokanForm } from './AnsokanForms/LegAnsokanForm';
import { AnsokanSaveCloseBar } from './AnsokanForms/AnsokanSaveCloseBar';
import { StepTwoSubmitButton } from './StepTwoSubmitButton/StepTwoSubmitButton';
import AttentionBox from 'sos-common/js/components/AttentionBox/Attentionbox';
import { FilKomplettering } from './FilKomplettering/FilKomplettering';
import { ReCaptchaWrapper } from './PublicForm/ReCaptchaWrapper';
import { InfoBubbleLink } from './InfoBubbleLink/InfoBubbleLink';
import { StartNewAnsokan } from './StartNewAnsokan/StartNewAnsokan';
import { TitleWithTextData } from './TitleWithTextData/TitleWithTextData';
import { TitleWithSelectBoxData } from './TitleWithSelectBoxData/TitleWithSelectBoxData';
import { MultipleTextInputs } from './MultipleTextInputs/MultipleTextInputs';
import { IntygStepTwoSubmitButton } from './IntygStepTwoSubmitButton/IntygStepTwoSubmitButton';
import { YrkesVal } from './SpecialistKompetens/YrkesVal';
import { IntygKomplettering } from './IntygKomplettering/IntygKomplettering';
import { IntygApplication } from './IntygApplication/IntygApplication';
import { SkyddadYrkestitelAnsokanForm } from './AnsokanForms/SkyddadYrkestitelAnsokanForm/SkyddadYrkestitelAnsokanForm';
import { SkyddadYrkestitelWrapper } from './SkyddadYrkestitelPublicForm/SkyddadYrkestitelWrapper';
import { SpecialistbevisAnsokanForm } from './AnsokanForms/Specialistbevis/SpecialistbevisAnsokanForm';

//common components
import { MainMenu } from 'sos-common/js/components/MainMenu/MainMenu';
import { MenuBreadCrumbs } from 'sos-common/js/components/MenuBreadCrumbs/MenuBreadCrumbs';
import { SubWebGlobalSearch } from 'sos-common/js/components/SubWebGlobalSearch/SubWebGlobalSearch';
import { SiteHeader } from 'sos-common/js/components/SiteHeader/SiteHeader';
import { BreadCrumbs } from 'sos-common/js/components/BreadCrumbs/BreadCrumbs';
import { Notification } from 'sos-common/js/components/Notification/Notification';
import { Hero } from 'sos-common/js/components/Hero/Hero';
import { TagList } from 'sos-common/js/components/TagList/TagList';
import { Lazyloader } from 'sos-common/js/components/Lazyloader/Lazyloader';
import { ShareWidget } from 'sos-common/js/components/ShareWidget/ShareWidget';
import { Search } from 'sos-common/js/components/Search/Search';
import { SearchList } from 'sos-common/js/components/SearchList/SearchList';
import { Fileupload } from 'sos-common/js/components/Fileupload/Fileupload';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { MultiSelectCombobox } from 'sos-common/js/components/MultiSelectCombobox/MultiSelectCombobox';
import { CurrentEvent } from 'sos-common/js/components/CurrentEvent/CurrentEvent';
import { CurrentCalendar } from 'sos-common/js/components/CurrentCalendar/CurrentCalendar';
import { VerticalProgress } from 'sos-common/js/components/VerticalProgress/VerticalProgress';
import { ChapterList } from 'sos-common/js/components/ChapterList/ChapterList';
import { InputError } from 'sos-common/js/components/InputError/InputError';
import { ChapterSidebar } from 'sos-common/js/components/ChapterList/ChapterSidebar';
import { Icon } from 'sos-common/js/components/Icon/icon';
import { Tooltip } from 'sos-common/js/components/Tooltip/Tooltip';
import { DesktopLanguagePicker } from 'sos-common/js/components/DesktopLanguagePicker/DesktopLanguagePicker';
import { TreeView } from 'sos-common/js/components/SubNavigation/TreeView';
import { ActualListening } from 'sos-common/js/components/ActualListening/ActualListening';
import { WizardStepperStatic } from 'sos-common/js/components/WizardStepperStatic/WizardStepperStatic';
import { AcceptConditions } from 'sos-common/js/components/AcceptConditions/AcceptConditions';
import { SureDelete } from 'sos-common/js/components/SureDelete/SureDelete';
import { CalendarPageList } from 'sos-common/js/components/CalendarPageList/CalendarPageList';
import { CalendarArchiveList } from 'sos-common/js/components/CalendarArchiveList/CalendarArchiveList';
import { VideoBlock } from 'sos-common/js/components/VideoBlock/VideoBlock';
import { CookieConsentManager } from 'sos-common/js/components/CookieConsentManager/CookieConsentManager';
import { LinkPuff } from 'sos-common/js/components/LinkPuff/LinkPuff';
import { TabComponent } from 'sos-common/js/components/TabComponent/TabComponent';
import { ExpanderGroup } from 'sos-common/js/components/ExpanderGroup/ExpanderGroup';
import { Analytics } from 'sos-common/js/components/Analytics/Analytics';
import { Dialog } from 'sos-common/js/components/Dialog/Dialog';

import { UtbildningsTypVal } from './SpecialistKompetens/UtbildningsTypVal';

const { EServicesSiteHeader, EServiceFormMenu, SessionHandler, DeleteButton } = EserviceCommon;

export {
  SiteHeader,
  Hero,
  BreadCrumbs,
  Notification,
  TagList,
  Lazyloader,
  ShareWidget,
  Search,
  CurrentEvent,
  CurrentCalendar,
  SearchList,
  SubWebGlobalSearch,
  MenuBreadCrumbs,
  TreeView,
  CalendarPageList,
  CalendarArchiveList,
  DesktopLanguagePicker,
  ActualListening,
  Icon,
  MainMenu,
  VideoBlock,
  CookieConsentManager,
  EServicesSiteHeader,
  DeleteButton,
  PreAnsokan,
  LegAnsokanForm,
  WizardStepperStatic,
  AnsokanSaveCloseBar,
  TabComponent,
  StepTwoSubmitButton,
  AttentionBox,
  VerticalProgress,
  FilKomplettering,
  ReCaptchaWrapper,
  ChapterList,
  ChapterSidebar,
  InfoBubbleLink,
  StartNewAnsokan,
  TitleWithTextData,
  TitleWithSelectBoxData,
  MultipleTextInputs,
  IntygStepTwoSubmitButton,
  YrkesVal,
  IntygKomplettering,
  IntygApplication,
  ExpanderGroup,
  InputError,
  LinkPuff,
  SkyddadYrkestitelAnsokanForm,
  SkyddadYrkestitelWrapper,
  Analytics,
  SpecialistbevisAnsokanForm,
  UtbildningsTypVal,
  MultiSelectCombobox,
};
